import React from 'react';
import Typography from '@mui/material/Typography';
import {Card, CardContent} from '@mui/material';
import classNames from './AgreementForm.module.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

type AgreementFormProps = {
    confirmName: string,
    name: string,
    onSubmit: () => void,
    setConfirmName: (nextValue: string) => void,
    setName: (nextValue: string) => void,
}

export const AgreementForm = (props: AgreementFormProps) => {
    const {
        confirmName,
        name,
        onSubmit,
        setConfirmName,
        setName,
    } = props

    return (
        <Card className={classNames.card}>
            <CardContent>
                <Typography variant="h5">You must agree to the below terms to continue.</Typography>
                <Typography className={classNames.body} variant="body1">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </Typography>

                <div className={classNames.inputsContainer}>
                    <TextField
                        label="Full Legal Name"
                        variant="outlined"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <TextField
                        label="Confirm Full Legal Name"
                        variant="outlined"
                        value={confirmName}
                        onChange={(e) => setConfirmName(e.target.value)}
                    />
                </div>

                <Button
                    className={classNames.button}
                    variant="contained"
                    disabled={name === '' || name !== confirmName}
                    onClick={onSubmit}
                >
                    Next
                </Button>
            </CardContent>
        </Card>
    )
}
